<template>
  <div class="body">
    <div class="left">
      <search-filters />
      <alternative-filters
        v-if="
            hasSelectedResult &&
            $store.state.search.alternative == 'led' &&
            showAlternativeFilters
        "
      />
    </div>
    <div class="right">
      <!-- Search bar -->
      <search @search="search" />

      <!-- Filter list and result picker -->
      <div class="search-info-bar">
        <div class="left">
          <SearchFilterList />
        </div>
        <div class="right">
          <ResultPicker v-if="hasSelectedResults" />
        </div>
      </div>

      <!-- Results -->
      <div v-if="$store.state.search.loadingSearch" class="loading-indicator">
        <font-awesome-icon
          class="spinner"
          icon="spinner"
          spin
        ></font-awesome-icon>
      </div>
      <div v-else>
        <search-result-list v-if="$store.state.search.showSearchResults" />
        <Matches
          v-if="!$store.state.search.showSearchResults && hasSelectedResult"
          :result="selectedResult"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SearchFilters from '@/components/SearchFilters';
import AlternativeFilters from '@/components/AlternativeFilters.vue';
import SearchFilterList from '@/components/SearchFilterList';
import Search from '@/components/Search';
import SearchResultList from '@/components/SearchResultList';
import Matches from '@/components/Matches';
import ResultPicker from '@/components/ResultPicker';

export default {
  components: {
    SearchFilters,
    AlternativeFilters,
    SearchFilterList,
    Search,
    SearchResultList,
    Matches,
    ResultPicker,
  },

  computed: {
    activeResult() {
      return this.$store.state.search.selectedResult;
    },

    results() {
      const results = this.$store.state.search.results;
      return results;
    },

    hasResults() {
      return this.$store.state.search.searchResults.length > 0;
    },

    // Checks if there are any previously selected results
    hasSelectedResults() {
      return this.$store.state.search.results.length > 0;
    },

    hasSelectedResult() {
      return (
        this.$store.state.search.results.length > 0 && this.activeResult >= 0
      );
    },

    showAlternativeFilters() {
      return this.selectedResult.matches.map(e => e.match).length > 1;
    },

    selectedResult() {
      return this.$store.state.search.results[
        this.$store.state.search.selectedResult
      ];
    },
  },

  methods: {
    // Result controls

    search() {
      this.$store.state.search.showSearchResults = true;
    },
  },
};
</script>

<style scoped lang="scss">
.loading-indicator {
  width: 100%;
  font-size: 30px;
  text-align: center;
}

.body {
  display: flex;

  @include media-breakpoint-down(sm) {
    flex-direction: column;
  }

  .search-bar {
    margin-bottom: 20px;
  }

  & > .left {
    min-width: 220px;
    max-width: 220px;
    margin-right: 20px;

    @include media-breakpoint-down(sm) {
      min-width: 100%;
      max-width: 100%;
      margin-right: 0;
      margin-bottom: 20px;
    }
  }

  & > .right {
    flex: 1;
  }
}

// Search info

.search-info-bar {
  display: flex;
  font-size: $nc-fsz-normal;
  margin-bottom: 20px;

  .left {
    flex: 1;
    margin-right: 20px;
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }

  .right {
    flex-basis: 140px;

    @include media-breakpoint-down(sm) {
      flex: 1;
      flex-basis: auto;
    }
  }
}
</style>
